//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  AddIcon,
  ArrowBackIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Editable,
  EditableInput,
  EditablePreview,
  Flex,
  Grid,
  Icon,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Fixed from "../components/layout/Fixed";
import { XButton } from "../components/ui-elements/Icon";
// import { UploadIcon } from "../icons";
import { isValidObject } from "../utils/functions";
import { SingleFormButton } from "./forms/FormButtons";

const centerProps: any = {
  alignItems: "center",
  justifyItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};

const smallDropZoneWrapper: any = {
  p: 3,
  mb: 4,
  h: 200,
  display: "inline-flex",
  cursor: "pointer",
  borderRadius: 4,
  borderStyle: "dashed",
  borderWidth: "2xs",
  rounded: "lg",
  borderColor: "gray.400",
  _focus: { outline: "none" },
  boxSizing: "border-box",
};

const gridStyling = {
  mt: 6,
  gridTemplateColumns: "repeat(auto-fill, minmax(231px, 1fr))",
  gridColumnGap: 5,
  gridRowGap: 6,
};

const largeDropZoneWrapper: any = {
  h: [200, 360],
  w: "100%",
  p: 5,
  borderStyle: "dashed",
  borderWidth: "xs",
  rounded: "lg",
  borderColor: "gray.400",
  cursor: "pointer",
  _focus: { outline: "none" },
};

const largeDropZoneInner = {
  h: "100%",
  w: "100%",
  rounded: "lg",
  background:
    "url(https://a0.muscache.com/airbnb/static/packages/upload-photos-ghosts.56fe723d.png)",
  backgroundPosition: "center",
};

const overlayStyling: any = {
  top: 2,
  left: 2,
  bg: "black",
  opacity: 0.7,
  rounded: "lg",
  display: "none",
  _groupHover: { display: "inline-flex" },
  borderWidth: "2xs",
  position: "absolute",
  borderColor: "gray.600",
};

const deleteButtonStyling: any = {
  top: 2,
  left: 2,
  rounded: "full",
  colorScheme: "red",
  size: "md",
  display: "none",
  _groupHover: { display: "inline-flex" },
  position: "absolute",
  borderColor: "red.400",
};

const imageStyling: any = {
  objectFit: "cover",
  rounded: "lg",
  w: "100%",
  h: "100%",
  alt: "Preview Image",
};

const previewWrapper = {
  p: 0,
  role: "group",
  cursor: "inherit",
  borderWidth: "2xs",
  position: "relative",
};

const largePrevewProps: any = {
  top: [2, 4],
  left: [2, 4],
  py: 2,
  px: 4,
};

const inputProps = {
  mt: 3,
  w: "100%",
  fontSize: "xl",
  placeholder: "Add a caption",
};

const buttonProps = {
  size: "sm",
  color: "white",
  variant: "link",
};

const imageErrorProps: any = {
  px: 3,
  py: 2,
  _hover: { cursor: "pointer" },
  position: "absolute",
  top: [2, 4],
  left: [2, 4],
  bg: "white",
  borderWidth: "2xs",
  borderColor: "red.400",
  color: "red.500",
  fontSize: "sm",
  rounded: "md",
};

const SubjectPhotos: React.FC<{
  initialPhotos: Array<any>;
  onBackClick: () => void;
  onSubmit: (params: any) => Promise<any>;
  onDelete: (params: any) => Promise<any>;
  subject?: string;
  loading?: boolean;
  accept?: string;
}> = observer(
  ({
    initialPhotos = [],
    onBackClick,
    loading,
    onSubmit,
    onDelete,
    subject,
    accept = "image/jpeg, image/png",
  }) => {
    const [photos, setPhotos] = useState(initialPhotos);
    const [editIndex, setEditIndex] = useState({});
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isDeleting, setIsDeleting] = useState(false);

    const editPhoto = (photoIndex) => {
      setEditIndex(photos[photoIndex]);
      onOpen();
    };

    ////////////////////////////

    const deletePhoto = async (index) => {
      try {
        setIsDeleting(true);
        const photo = photos[index];
        if (photo.id) {
          await onDelete(photo);
        }
        let newArray = photos.filter((_, photoIndex) => photoIndex !== index);
        setPhotos(newArray);
        setIsDeleting(false);
      } catch (error) {
        console.log(error);
        setIsDeleting(false);
        throw error;
      }
    };

    ////////////////////////////

    const updateInputChange = (e: string, index: number) => {
      let oldPhotos = photos;
      let newPhoto = { ...photos[index], caption: e };
      oldPhotos[index] = newPhoto;
      setPhotos(oldPhotos);
    };

    ////////////////////////////
    useEffect(() => {
      // async function initialize(_photos: any) {
      //   _photos.forEach((photo) => URL.revokeObjectURL(photo.preview));
      //   let result = await toBase64(_photos);
      // }
      // initialize(photos);
      // photos.forEach((photo) => URL.revokeObjectURL(photo.preview));
      // let result = await toBase64(photos);
      // console.log(result);
    }, [photos]);

    function toBase64(files) {
      let promises = files.map(
        (file, index) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            if (file) {
              reader.readAsDataURL(file);
            }
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
          }),
      );
      return Promise.all(promises);
    }

    const { getRootProps, getInputProps } = useDropzone({
      accept: accept,
      onDrop: async (acceptedFiles) => {
        let newPhotos = acceptedFiles.map((photo) =>
          Object.assign(photo, {
            preview: URL.createObjectURL(photo),
          }),
        );
        let ph = await toBase64(newPhotos);
        setPhotos([
          ...photos,
          ...ph.map((o, i) => ({ preview: o, file: newPhotos[i] })),
        ]);
      },
    });
    const previewPhotos = [];
    for (let i = 1; i < photos.length; i++) {
      previewPhotos.push(photos[i]);
    }

    const photoErrors = photos.filter((photo) => Boolean(photo.error));

    return (
      <Flex {...centerProps} mb={24}>
        <Box className="subject-photo">
          <Button
            mb={6}
            onClick={onBackClick}
            leftIcon={<ArrowBackIcon />}
            variant="link"
            colorScheme="blue"
          >
            Back
          </Button>

          <Stack pb={6}>
            <Text fontSize="3xl" lineHeight="shorter" fontWeight="bold" as="h1">
              Add subject photos
            </Text>
            <Text mt={1} color="gray.700">
              Showcase your {subject} skill by sharing relevant, high-quality
              images you have - if any. This is optional, and should only be
              used to help clients decide to book lessons with you.
            </Text>

            <Box pt={3}>
              <Alert status="warning" variant="left-accent">
                <AlertTitle fontSize="sm" lineHeight="short">
                  Images must be high-quality and must not contain any contact
                  details
                </AlertTitle>
              </Alert>
            </Box>
          </Stack>

          <Stack>
            <MainDropZone
              onDeletePhoto={() => deletePhoto(0)}
              onEditPhoto={() => editPhoto(0)}
              onInputChange={(e: string) => {
                updateInputChange(e, 0);
              }}
              isDeleting={isDeleting}
              {...{ photos, getRootProps, getInputProps }}
            />

            {photos.length > 0 && (
              <Grid {...gridStyling}>
                {previewPhotos.map((photo, index) => (
                  <AdditionalDropZone
                    onDeletePhoto={() => deletePhoto(index + 1)}
                    onEditPhoto={() => editPhoto(index + 1)}
                    onInputChange={(e) => updateInputChange(e, index + 1)}
                    key={photo.name}
                    isDeleting={isDeleting}
                    {...{ photo, getRootProps, getInputProps }}
                  />
                ))}

                <SmallDropZone {...{ getRootProps, getInputProps }} />
              </Grid>
            )}
          </Stack>
        </Box>

        {isValidObject(editIndex) && (
          <PhotoEditModal photo={editIndex} {...{ isOpen, onClose }} />
        )}

        <SingleFormButton
          ml={0}
          nextText="Save images"
          isLoading={loading}
          isDisabled={photoErrors.length > 0}
          onNextClick={() => onSubmit(photos)}
        />
      </Flex>
    );
  },
);

export default SubjectPhotos;

const MainDropZone: React.FC<{
  onInputChange: any;
  onDeletePhoto: any;
  onEditPhoto: any;
  photos?: any[];
  isDeleting: boolean;
}> = (props) => {
  let displayPhoto = props.photos && props.photos[0];
  if (displayPhoto) {
    displayPhoto.error = false;
  }
  return props.photos && props.photos.length > 0 ? (
    <LargePreview
      photo={displayPhoto}
      {...props}
      errorMessage="This is an invalid image"
    />
  ) : (
    <LargeDropZone {...(props as any)} />
  );
};

const AdditionalDropZone = (props) => {
  let newPhoto = { ...props.photo, error: false };
  return props.photo ? (
    <SmallPreview
      {...props}
      photo={newPhoto}
      errorMessage="This is an invalid image"
    />
  ) : (
    <SmallDropZone {...props} />
  );
};

const PhotoEditModal: React.FC<{
  isOpen?: any;
  onClose?: any;
  photo?: any;
  onSave?: any;
}> = ({ isOpen, onClose, photo, onSave }) => {
  return (
    <Modal
      size={"lg"}
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent rounded="md">
        <ModalHeader>Edit photo </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex
            {...centerProps}
            overflow="hidden"
            w={["100%", "90%"]}
            mx="auto"
          >
            <Flex overflow="hidden" {...centerProps} p={[5, 6, 12]}>
              <Image src={photo.preview} {...imageStyling} rounded="md" />
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const LargeDropZone = ({ getRootProps, getInputProps }) => {
  return (
    <Box {...getRootProps({ className: "dropzone" })} {...largeDropZoneWrapper}>
      <Flex {...largeDropZoneInner} {...centerProps}>
        <Stack {...centerProps}>
          <Input {...getInputProps()} />
          <XButton
            size="lg"
            variant="outline"
            leftIcon={"upload"}
            colorScheme="green"
          >
            Upload photos
          </XButton>
          <Text display={["none", "block"]} color="gray.600">
            or drag them in
          </Text>
        </Stack>
      </Flex>
    </Box>
  );
};

const SmallDropZone = ({ getRootProps, getInputProps }) => {
  return (
    <Box
      {...smallDropZoneWrapper}
      {...centerProps}
      {...getRootProps({ className: "dropzone" })}
    >
      <Flex overflow="hidden" {...centerProps}>
        <Stack {...centerProps} color="gray.400">
          <Input {...getInputProps()} />
          <Icon as={AddIcon} fontSize="xl" />
          <Text fontSize="xl">Add another</Text>
        </Stack>
      </Flex>
    </Box>
  );
};

const SmallPreview: React.FC<{
  photo: { preview: string; error?: boolean; caption: string };
  onDeletePhoto: any;
  errorMessage?: string;
  onEditPhoto: any;
  onInputChange: any;
  isDeleting: boolean;
}> = ({
  photo,
  onDeletePhoto,
  errorMessage,
  onEditPhoto,
  onInputChange,
  isDeleting,
}) => {
  return (
    <Box>
      <Box {...smallDropZoneWrapper} {...previewWrapper}>
        {photo.error ? (
          <ImageError {...{ onDeletePhoto, errorMessage }} />
        ) : (
          <DeleteEdit {...{ onEditPhoto, onDeletePhoto, isDeleting }} />
        )}

        <Flex overflow="hidden" {...centerProps}>
          <Image src={photo.preview} {...imageStyling} />
        </Flex>
      </Box>
      <Editable
        {...inputProps}
        onChange={onInputChange}
        mt={-2}
        fontSize="md"
        defaultValue={photo.caption}
      >
        <EditablePreview />
        <EditableInput _focus={{ outline: "none" }} />
      </Editable>
    </Box>
  );
};

const LargePreview: React.FC<{
  photo: { preview: string; error?: boolean; caption: string };
  onEditPhoto: any;
  errorMessage?: string;
  onDeletePhoto: any;
  onInputChange: any;
  isDeleting: boolean;
}> = ({
  photo,
  onEditPhoto,
  errorMessage,
  onDeletePhoto,
  onInputChange,
  isDeleting,
}) => {
  return (
    <Box>
      <Box {...largeDropZoneWrapper} {...previewWrapper}>
        {photo.error ? (
          <ImageError {...{ onDeletePhoto, errorMessage }} />
        ) : (
          <DeleteEdit {...{ onEditPhoto, onDeletePhoto, isDeleting }} />
        )}

        <Flex {...largeDropZoneInner} {...centerProps} overflow="hidden">
          <Image src={photo.preview} {...imageStyling} />
        </Flex>
      </Box>

      <Editable
        {...inputProps}
        onChange={onInputChange}
        defaultValue={photo.caption}
      >
        <EditablePreview />
        <EditableInput _focus={{ outline: "none" }} />
      </Editable>
    </Box>
  );
};

const DeleteEdit = ({ onDeletePhoto, onEditPhoto, isDeleting }) => {
  const [removePhoto, setRemovePhoto] = useState(false);
  return (
    <Box>
      {removePhoto && (
        <Button
          onBlur={() => setRemovePhoto(false)}
          {...deleteButtonStyling}
          {...largePrevewProps}
          onClick={onDeletePhoto}
          isLoading={isDeleting}
          loadingText="Removing photo"
          fontSize="sm"
        >
          Remove photo?
        </Button>
      )}
      {!removePhoto && (
        <Box {...overlayStyling} {...largePrevewProps}>
          <Button
            mr={5}
            leftIcon={<DeleteIcon />}
            {...buttonProps}
            onClick={() => setRemovePhoto(true)}
          >
            Delete
          </Button>
          <Button
            leftIcon={<EditIcon />}
            {...buttonProps}
            onClick={onEditPhoto}
          >
            Edit
          </Button>
        </Box>
      )}
    </Box>
  );
};

const ImageError = ({
  onDeletePhoto,
  errorMessage = "Image is rejected",
}: any) => {
  return (
    <Box {...imageErrorProps} onClick={onDeletePhoto}>
      <Text fontWeight="bold">{errorMessage}</Text>
      <Stack mt={1} isInline align="center">
        <Icon name="delete" />
        <Text fontWeight="medium">Delete</Text>
      </Stack>
    </Box>
  );
};

const FormButtons: React.FC<{
  onBackClick: () => void;
  onNextClick?: () => void;
  backText?: string;
  nextText?: string;
  hideBackButton?: boolean;
  hideSaveButton?: boolean;
  buttonSize?: string;
  isLoading?: boolean;
  photos?: Array<any>;
  loadingText?: string;
  width?: Array<string>;
}> = ({
  onBackClick,
  onNextClick,
  backText = "Back",
  nextText = "Next",
  hideBackButton,
  hideSaveButton,
  buttonSize = "lg",
  isLoading = false,
  photos = [],
  loadingText = "Submitting",
  width = ["100%", "100%", "60%"],
}) => {
  const photoErrors = photos.filter((photo) => Boolean(photo.error));
  const hasErrors = photoErrors.length > 0;
  return (
    <Fixed
      py={[4, 5, 4]}
      px={[5, 0]}
      width={width}
      bottom="0%"
      borderTopWidth="2xs"
      borderColor="gray.200"
      bg="white"
    >
      <Flex justify="space-between" align="center">
        {hideBackButton ? (
          <Box />
        ) : (
          <Button
            variant="link"
            leftIcon={<ChevronLeftIcon />}
            onClick={onBackClick}
          >
            {backText}
          </Button>
        )}

        {!hideSaveButton && (
          <Box ml={["none", "auto"]} width={[4 / 7, 1 / 4]}>
            <Button
              type="submit"
              isLoading={isLoading}
              loadingText={loadingText}
              isDisabled={hasErrors}
              size={buttonSize}
              rightIcon={<ChevronRightIcon />}
              isFullWidth
              colorScheme="teal"
              onClick={onNextClick}
            >
              {nextText}
            </Button>
          </Box>
        )}
      </Flex>
    </Fixed>
  );
};

//TODO: Actions on Preview. 1. Delete 2. Change Photo. 3. Rotate Right 4. Rotate Left 5. Crop
